// eslint-disable-next-line import/prefer-default-export

export const appMutations = {
    TOGGLE_SIDEBAR: (state) => {
        state.sidebarStatus = !state.sidebarStatus
    },
    OPEN_SIDEBAR: (state) => {
        state.sidebarStatus = true
    },
    CLOSE_SIDEBAR: (state) => {
        state.sidebarStatus = false
    },
    SET_SIDEBAR_STATUS: (state, payload) => {
        state.sidebarStatus = payload
    },
    LOADING: (state, payload) => {
        state.loading += payload
    },
    SET_APPLICATION_TITLE: (state, payload) => {
        state.appTitle = payload
        document.title = payload
    },
    SET_CONSTANTS: (state, payload) => {
        state.constants = payload
    },
    SET_LANG_CODE: (state, payload) => {
        state.lang_code = payload
    }

};